<template>
  <i @click="back"
     title="返回"
     class="iconfont icon-fanhui icon-back"
  ></i>
</template>

<script>
export default {
  name: 'HtToBack',
  components: {},
  props: ['special'],
  data () {
    return {}
  },
  mounted () {},
  methods: {
    back () {
      if (!this.special) {
        this.$router.back()
      } else {
        this.$emit('back')
      }
    }
  }
}
</script>

<style scoped lang="less">
  .icon-back {
    float: left;
    margin-right: 15px;
    font-size: 32px;
    cursor: pointer;
    &:hover {
      color: #ccc;
    }
  }
</style>
